import Phaser from 'phaser';

export class CongratsMessageForInstantWin extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, messageBoxWidth: number = 0, messageBoxHeight: number = 0, messages, container?, hold: number = 2000) {
    super(scene);
    const graphics = scene.make.graphics({
      x: 0,
      y: 0,
      add: false
    });
    graphics.fillStyle(0x000000, 0.5);
    graphics.fillRect(20, 2, messageBoxWidth - 25 , messageBoxHeight - 5);
    graphics.setInteractive(new Phaser.Geom.Rectangle(0, 0, scene.physics.world.bounds.width, scene.physics.world.bounds.height), Phaser.Geom.Rectangle.Contains);

    graphics.setDepth(0);
    this.add(graphics);
    this.scene.add.existing(this);

    const sceneCenterX = scene.physics.world.bounds.width * 0.5;
    const sceneCenterY = scene.physics.world.bounds.height * 0.5;
    if (messageBoxWidth === 0) messageBoxWidth = scene.physics.world.bounds.width * 0.8;
    if (messageBoxHeight === 0) messageBoxHeight = scene.physics.world.bounds.height * 0.8;
    this.alpha = 0;
    this.depth = 1000;
    this.width = messageBoxWidth;
    this.height = messageBoxHeight;
    this.x = sceneCenterX - messageBoxWidth / 2;
    this.y = sceneCenterY - messageBoxHeight / 2;
    const backgroundImage = scene.add
      .image(messageBoxWidth / 2, messageBoxHeight / 2, 'content-background')
      .setDisplaySize(messageBoxWidth, messageBoxHeight)
      .setOrigin(0.5);
    this.add(backgroundImage);

    if (container) {
      this.add(container);
    }

    messages.forEach(message => {
      const color = message.color ? message.color : '#FFFFFF';
      const fontSize = message.fontSize ? message.fontSize : '20px';
      const fontFamily = message.fontFamily ? message.fontFamily : 'Metropolis';
      const text = this.scene.add
        .text(0, message.yPos, message.text, { color: color, font: fontSize + ' ' + fontFamily, ...message.styles })
        .setOrigin(message.center ? 0.5 : 0);
      text.x = message.center ? messageBoxWidth * 0.5 : message.xPos;
      this.add(text);
    });

    scene.add.existing(this);
    scene.tweens.add({
      alpha: 2,
      ease: 'Linear',
      duration: 500,
      targets: this,
      repeat: 0,
      yoyo: true,
      hold
    });
  }
}
